import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { Connector } from '@domain/connection/models/Connector';

export const useChannelDockConnector = () => {
  const { data: connector, isLoading, error } = useQuery<Connector | undefined>({
    queryKey: ['channeldock-connector'],
    queryFn: async () => {
      const result = await container.marketplaceRepository.fetchConnectors();
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data.find(item => item.type === 'channeldock');
    },
  });

  return { connector, isLoading, error };
};

export const useChannelDockInventoryPreview = (connectionId: string) => {
  const { data: inventory, isLoading, error } = useQuery({
    queryKey: ['channeldock-inventory-preview', connectionId],
    queryFn: async () => {
      const result = await container.channeldockConnectorRepository.fetchInventory(connectionId);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    enabled: !!connectionId,
  });

  return {
    inventory: inventory || [],
    isLoading,
    error,
  };
};
